import DOMPurify from 'dompurify'

export const sanitizeEventoHtml = (html: string) =>
  DOMPurify.sanitize(html, { ALLOWED_TAGS: ['b', 'strong', 'br'], ALLOWED_ATTR: [] })
